import { applyEach, minLength, pattern, required, schema, SchemaPathTree, validate } from '@angular/forms/signals';
import { VALIDATION_PATTERNS } from '@dss-libs/shared/type/common-types';
import { isPhoneNumberValid } from '@dss-libs/shared/utility/common-utilities';
import { IRecipientFormModel, IRecipientInformationFormModel } from '@dss-libs/portal/type/portal-types';

export const recipientSchema = schema((recipient: SchemaPathTree<IRecipientFormModel>) => {
  required(recipient.name, { message: 'VALIDATION_MESSAGES.NAME_INVALID' });
  required(recipient.email, { message: 'VALIDATION_MESSAGES.EMAIL_REQUIRED' });
  pattern(recipient.email, VALIDATION_PATTERNS.email, { message: 'VALIDATION_MESSAGES.EMAIL_INVALID' });
  validate(recipient.phone, ({ value }) => {
    const { countryCode, phoneNumber } = value();
    if (!countryCode) return { kind: 'countryCodeRequired', message: 'VALIDATION_MESSAGES.REQUIRED' };
    if (!phoneNumber || isPhoneNumberValid(phoneNumber, countryCode)) return undefined;
    return { kind: 'invalidPhoneNumber', message: 'VALIDATION_MESSAGES.INVALID_PHONE_NUMBER' };
  });
});

export const recipientInformationSchema = schema((path: SchemaPathTree<IRecipientInformationFormModel>) => {
  minLength(path.steps, 1);
  applyEach(path.steps, (step) => {
    minLength(step.recipients, 1);
    applyEach(step.recipients, recipientSchema);
  });
});
